import styled from '@emotion/styled'

import { colors } from '@/constants'

export const QuestionIcon = styled.button<{ size?: string; fontSize?: string }>`
  border-radius: 9999px;
  width: ${({ size }) => size || '1.5rem'};
  height: ${({ size }) => size || '1.5rem'};

  font-family: Hauora;
  font-size: ${({ fontSize }) => fontSize || '13px'};
  font-weight: 800;
  letter-spacing: -0.006em;
  color: white;
  background-color: ${colors.darkBlue4};

  transition-property: background-color;
  transition-duration: 250ms;

  &:hover:not(:disabled) {
    background-color: ${colors.darkBlue1};
  }
  &:active:not(:disabled) {
    background-color: ${colors.darkBlue3};
  }

  &:focus:not(:disabled) {
    background-color: ${colors.blue};
  }

  &:focus-visible:not(:disabled) {
    background-color: ${colors.blue};
  }
`
